import React from "react";
import "./contact-link.scss";
import RenderCellContent from "../mui-table/render-cell-content";

type ContactType = "Email" | "Phone" | "website";

type ContactLinkProps = {
  type: ContactType;
  value: string;
  className?: string;
  id?: any;
};

const ContactLink: React.FC<ContactLinkProps> = ({
  type,
  value,
  className,
  id,
}) => {
  if (!value) return null;

  const hanleActivityLog = async () => {
    try {
      const payload = {
        contactValue: value,
        contactType: type === "Phone" ? "Call" : type,
      };
    } catch (error) {
      console.error(error);
    }
  };

  let href = "";
  switch (type) {
    case "Email":
      href = `mailto:${value}`;
      break;
    case "Phone":
      href = `tel:${value}`;
      break;
    case "website":
      href =
        value.startsWith("http://") || value.startsWith("https://")
          ? value
          : `https://${value}`;
      break;
    default:
      return null;
  }

  return (
    <>
      {value === "-" ? (
        <div>{value}</div>
      ) : (
        <a
          href={href}
          target={type === "website" ? "_blank" : undefined}
          rel={type === "website" ? "noopener noreferrer" : undefined}
          className={`contact-link ${className || ""}`}
          onClick={() => {
            if (id) {
              hanleActivityLog();
            }
          }}
        >
          <RenderCellContent text={value} />
        </a>
      )}
    </>
  );
};

export default ContactLink;
